import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import {
  Button,
  Tabbar,
  TabbarItem,
  Loading,
  Toast,
  DropdownMenu,
  DropdownItem,
  Divider,
  ActionSheet,
} from 'vant';
import {
  getUserInfo,
  setUserInfo,
  awtSsoRefreshtokenApi,
  authService,
} from '@/service/api-service';
import { shareUrl, wxShareUr } from '@/assets/unit/shareConfig';

const app = createApp(App);
app.use(Button);
app.use(Tabbar);
app.use(TabbarItem);
app.use(Loading);
app.use(Toast);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Divider);
app.use(ActionSheet);

router.beforeEach(async (to, from, next) => {
  const userInfo = getUserInfo();
  const isWechat = /micromessenger/i.test(navigator.userAgent);

  if ((to.path === '/audiovisual' || to.path === '/musicDetails') && !isWechat) {
    if (!userInfo) {
      if (window.config.isAwtSsoLogin && to.query.tk) {
        next('/login');
      }
    }
  }

  //删除储存的相关
  if (to.path != '/musicDetails') {
    localStorage.setItem('rym-app-aboutMusic', JSON.stringify([]));
    localStorage.setItem('rym-app-aboutMusicIndex', 0);
  }

  if (
    to.path != '/login' &&
    to.path != 'register' &&
    !to.path.includes('wxauth') &&
    !to.path.includes('binding')
  ) {
    localStorage.setItem('ryomapp-redirect-url', to.fullPath);
  }

  if (to.path != '/login' && to.path != from.path && to.path != '/paying') {
    if (to.path != '/leaseDetail' && from.path == '/home') {
      sessionStorage.setItem('rym-fromUrl', from.path);
    } else {
      sessionStorage.setItem('rym-fromUrl', from.fullPath); //保存缓存的返回路由
    }
  }

  //删除记录的专辑选中
  if (
    to.path != '/album' &&
    to.path != '/musicDetails' &&
    to.path != '/celebrityDetails'
  ) {
    localStorage.setItem('rym-app-albumId', -1);
  }

  if (to.path == '/album' && from.path != '/musicDetails') {
    // console.log('进入的是专辑详情且不是从乐谱返回的')
    sessionStorage.setItem('rym-album-fromUrl', from.fullPath); //保存缓存的返回路由
  }

  //记录进入名家信息前的页面-查看名家相关作品的情况
  if (
    (from.path == '/home' ||
      from.path == '/user' ||
      from.path == '/celebrity' ||
      from.path == '/celebritySearch' ||
      from.path == '/attention') &&
    to.path == '/celebrityDetails'
  ) {
    sessionStorage.setItem('rym-celebrity-fromUrl', from.fullPath); //保存缓存的返回路由
  }
  if (
    to.path == '/musicDetails' &&
    (from.path == '/home' ||
      from.path == '/musicSearch' ||
      from.path == '/user' ||
      from.path == '/myAlbumList' ||
      from.path == '/recentPreview')
  ) {
    sessionStorage.setItem('rym-fromMusicCele-fromUrl', from.fullPath);
  }

  if (from.path == '/musicDetails' && to.path == '/celebrityDetails') {
    sessionStorage.setItem('rym-celebrity-fromUrl', from.fullPath); //保存缓存的返回路由
  }

  //从乐谱进来的情况
  if (
    (from.path == '/home' ||
      from.path == '/musicSearch' ||
      from.path == '/user' ||
      from.path == '/myAlbumList' ||
      from.path == '/recentPreview' ||
      from.path == '/celebrityDetails') &&
    to.path == '/musicDetails'
  ) {
    sessionStorage.setItem('rym-musicDetails-fromUrl', from.fullPath); //保存缓存的返回路由
  }

  //记录所有路由
  let all = '';
  if (sessionStorage.getItem('rym-all-fromUrl')) {
    all = sessionStorage.getItem('rym-all-fromUrl');
  }
  if (
    to.fullPath == '/home' ||
    to.fullPath == '/celebrity' ||
    to.fullPath == '/user' ||
    to.fullPath == '/draft'
  ) {
    all = to.fullPath;
  } else {
    let arr = all.split('/');
    if ('/' + arr[arr.length - 1] != to.fullPath) {
      all += to.fullPath;
    }
  }

  sessionStorage.setItem('rym-all-fromUrl', all);

  // 判断设备类型


  next();
});

router.afterEach(async (to, from) => {
  $('html , body').animate({ scrollTop: 0 }, 0);

  let userInfo = getUserInfo();
  if (userInfo && window.config.isAwtSsoLogin) {
    awtSsoRefreshtokenApi(userInfo.token);
  }
});
app.use(router).mount('#app');
